export enum Event {
    CONNECT = 'connect',
    DISCONNECT = 'disconnect',
    CMP = 'MarketCurrentPrices',
    TRADED_ACTIVITY = 'CALL_ACTIVITY_TRADED',
    SHORTLISTED_ACTIVITY = 'CALL_ACTIVITY_SHORTLISTED',
    NEW_CALL = 'CALL_CREATED',
    // CALL_TAKEN = 'CallTaken',
    NOTIFICATION_EVENT = 'Notification',
    // REWARD = "Rewards",
    // WALLET_REWARD = "WalletReward",
    // ADMIN_ALERT = "Alert",
    MSG = 'MessageCreated',
    // DASHBOARD_ALERT = "DashboardAlert",
    // BUY_RANGE = "CallBuyRange",
    // MARKET_WATCH = "market_watch",
    // CALL_CALCULATIONS = "CallCalculation",
    // HOLDINGS_MARKET_PRICES = "wealthcase_market_current_prices",
    FEED_SUBSCRIBE = 'subscribe',
    FEED_UNSUBSCRIBE = 'deSubscribe',
    TRADE_FEED = "ltpEvent"
}